import {makeObservable, observable} from 'mobx';
import {v4} from 'uuid';

import type INotification from '@/models/Notifications';

export default class NotificationStore {
  public notifications: INotification[] = [];
  constructor() {
    makeObservable(this, {
      notifications: observable,
    });
  }

  public addNotification = (payload: INotification) => {
    if (!payload.id) {
      payload = {...payload, id: v4()};
    }
    this.notifications = [...this.notifications, payload];
  };

  public removeNotification = (id: string) => {
    this.notifications = this.notifications.filter((item: INotification) => item.id !== id);
  };
}
